// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c147eeb3","680":"4ab69a3a","915":"38e60344"}[chunkId] + ".chunk.js";
};